var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 11.5686V5.44859C20.9996 4.09859 20.4236 3.55859 18.9926 3.55859H15.3566C13.9256 3.55859 13.3496 4.09859 13.3496 5.44859V11.5686C13.3496 12.9186 13.9256 13.4586 15.3566 13.4586H18.9926C20.4236 13.4586 20.9996 12.9186 20.9996 11.5686Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 19.6702V18.0502C20.9996 16.7002 20.4236 16.1602 18.9926 16.1602H15.3566C13.9256 16.1602 13.3496 16.7002 13.3496 18.0502V19.6702C13.3496 21.0202 13.9256 21.5602 15.3566 21.5602H18.9926C20.4236 21.5602 20.9996 21.0202 20.9996 19.6702Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.65 13.5502V19.6702C10.65 21.0202 10.074 21.5602 8.643 21.5602H5.007C3.576 21.5602 3 21.0202 3 19.6702V13.5502C3 12.2002 3.576 11.6602 5.007 11.6602H8.643C10.074 11.6602 10.65 12.2002 10.65 13.5502Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.65 5.44859V7.06859C10.65 8.41859 10.074 8.95859 8.643 8.95859H5.007C3.576 8.95859 3 8.41859 3 7.06859V5.44859C3 4.09859 3.576 3.55859 5.007 3.55859H8.643C10.074 3.55859 10.65 4.09859 10.65 5.44859Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTab);
export default __webpack_public_path__ + "static/media/dashboardTab.560667b57ca06e7f60b5738fcce545df.svg";
export { ForwardRef as ReactComponent };